var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.117,
    height: 17.478,
    viewBox: "0 0 27.117 17.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2eb77d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 -20.996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 20.996)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.957,973.363a.9.9,0,0,0-.781.687l-2.231,9.434-1.262-1.893a.9.9,0,0,0-.753-.4H5.9A.9.9,0,1,0,5.9,983H11.44l2.147,3.22a.9.9,0,0,0,1.629-.292l1.695-7.156,1.958,11.317a.9.9,0,0,0,1.77.057l2.231-9.434,1.262,1.893a.9.9,0,0,0,.753.4L31.212,983a.9.9,0,1,0,0-1.808l-5.838.009-2.147-3.22a.9.9,0,0,0-1.629.292L19.9,985.424l-1.958-11.317a.9.9,0,0,0-.989-.744Z",
    transform: "translate(-15.999 -973.358)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveUsers);
export default __webpack_public_path__ + "static/media/active_users.db7379da53fe196e26aad4079efd7d2a.svg";
export { ForwardRef as ReactComponent };